import React, { useState, useEffect } from 'react';
import { ref, get, update } from 'firebase/database';
import { database } from '../../firebase/config';
import { formattaData } from '../../utils/dateUtils';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import PulsantiCondivisionePDF from '../PulsantiCondivisionePDF';
import { uploadImmagine } from '../../utils/cloudinaryUtils';

// ─── STILI PDF (identici a CreaBollaForm) ────────────────────────────────────
const pdfStyles = StyleSheet.create({
  page:        { padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
  title:       { fontSize: 16, fontWeight: 'bold', textAlign: 'center', marginBottom: 16 },
  section:     { marginBottom: 10 },
  row:         { flexDirection: 'row', marginBottom: 4 },
  label:       { fontWeight: 'bold', width: 160 },
  value:       { flex: 1 },
  tableHeader: { flexDirection: 'row', backgroundColor: '#e0e0e0', padding: 4, marginBottom: 2, fontWeight: 'bold' },
  tableRow:    { flexDirection: 'row', padding: 4, borderBottom: '1 solid #ccc' },
  col1:        { width: '40%' },
  col2:        { width: '30%' },
  col3:        { width: '30%' },
  divider:     { borderBottom: '1 solid #aaa', marginVertical: 8 },
  firmaImg:    { width: 200, height: 80, border: '1 solid #999' },
  footerRow:   { flexDirection: 'row', justifyContent: 'space-between', marginTop: 16 },
  footerCol:   { width: '45%' },
  footerLabel: { fontWeight: 'bold', marginBottom: 4 },
  prestazione: { marginTop: 4, lineHeight: 1.5 },
  // Intestazione con logo e recapiti
  intestazione:     { flexDirection: 'row', alignItems: 'center', marginBottom: 16, paddingBottom: 10, borderBottom: '1 solid #ccc' },
  logoImg:          { width: 80, height: 32, objectFit: 'contain' },
  recapiti:         { marginLeft: 12, fontSize: 9, color: '#333' },
  recapitiNome:     { fontSize: 10, fontWeight: 'bold', marginBottom: 2 },
  // Pagina 2 – foto pesata
  page2:          { padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
  page2Title:     { fontSize: 14, fontWeight: 'bold', textAlign: 'center', marginBottom: 12 },
  page2Subtitle:  { fontSize: 10, color: '#555', textAlign: 'center', marginBottom: 16 },
  fotoPesataImg:  { width: '100%', maxHeight: 620, objectFit: 'contain', border: '1 solid #ccc' },
  fotoPesataBox:  { width: '100%', height: 300, border: '1 solid #ccc', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f5f5f5' },
  fotoPesataNone: { color: '#999', fontSize: 12 },
numeroBollaBox:   { marginLeft: 'auto', backgroundColor: '#1a1a1a', borderRadius: 4, paddingVertical: 6, paddingHorizontal: 12, alignItems: 'center', justifyContent: 'center' },
numeroBollaLabel: { fontSize: 7, color: '#aaa', textTransform: 'uppercase', letterSpacing: 1 },
numeroBollaText:  { fontSize: 20, fontWeight: 'bold', color: '#ffffff' },


});

// ─── COMPONENTE PDF ───────────────────────────────────────────────────────────
function fmtData(d) {
  if (!d) return '';
  const parts = d.split('-');
  if (parts.length !== 3) return d;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

function BollaPDF({ dati }) {
  const {
    cliente, cantiere, data, mezzi,
    smaltimentoScavo, smaltimentoDemo,
    prestazione, nomeAutista,
    firmaBase64, fotoPesataUrl, numeroBolla,
  } = dati;

  return (
    <Document>
      {/* ── PAGINA 1 – Contenuto bolla ── */}
      <Page size="A4" style={pdfStyles.page}>
        {/* Intestazione: logo + recapiti ditta */}
<View style={pdfStyles.intestazione}>
  <Image src="CRG_logo.png" style={pdfStyles.logoImg} />
  <View style={pdfStyles.recapiti}>
    <Text style={pdfStyles.recapitiNome}>C.R.G. Scavi e trasporti Sagl</Text>
    <Text>Via Livio 5, 6830 Chiasso (TI)</Text>
    <Text>Tel: +41 78 751 32 51 - email:info@crgscavi.ch</Text>
  </View>
  {/* ── NUOVO: numero bolla ── */}
  {numeroBolla && (
    <View style={pdfStyles.numeroBollaBox}>
      <Text style={pdfStyles.numeroBollaLabel}>N° BOLLA</Text>
      <Text style={pdfStyles.numeroBollaText}>{numeroBolla}</Text>
    </View>
  )}
</View>

        <Text style={pdfStyles.title}>BOLLA DI LAVORO</Text>

        <View style={pdfStyles.section}>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Cliente</Text>
            <Text style={pdfStyles.value}>{cliente}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Cantiere</Text>
            <Text style={pdfStyles.value}>{cantiere}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Data</Text>
            <Text style={pdfStyles.value}>{fmtData(data)}</Text>
          </View>
        </View>

        <View style={pdfStyles.divider} />

        <View style={pdfStyles.section}>
          <Text style={{ fontWeight: 'bold', marginBottom: 4 }}>Mezzi utilizzati</Text>
          <View style={pdfStyles.tableHeader}>
            <Text style={pdfStyles.col1}>Mezzo</Text>
            <Text style={pdfStyles.col2}>Ore</Text>
            <Text style={pdfStyles.col3}>KM</Text>
          </View>
          {mezzi.filter(m => m.veicoloId).map((m, i) => (
            <View key={i} style={pdfStyles.tableRow}>
              <Text style={pdfStyles.col1}>{m.label}</Text>
              <Text style={pdfStyles.col2}>{m.ore || '-'}</Text>
              <Text style={pdfStyles.col3}>{m.km || '-'}</Text>
            </View>
          ))}
        </View>

        <View style={pdfStyles.divider} />

        <View style={pdfStyles.section}>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Smaltimento materiale da scavo (m³)</Text>
            <Text style={pdfStyles.value}>{smaltimentoScavo || '-'}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Smaltimento demolizione (m³)</Text>
            <Text style={pdfStyles.value}>{smaltimentoDemo || '-'}</Text>
          </View>
        </View>

        <View style={pdfStyles.divider} />

        <View style={pdfStyles.section}>
          <Text style={{ fontWeight: 'bold', marginBottom: 4 }}>Prestazione</Text>
          <Text style={pdfStyles.prestazione}>{prestazione || '-'}</Text>
        </View>

        <View style={pdfStyles.divider} />

        <View style={pdfStyles.footerRow}>
          <View style={pdfStyles.footerCol}>
            <Text style={pdfStyles.footerLabel}>Nome autista</Text>
            <Text>{nomeAutista}</Text>
          </View>
          <View style={pdfStyles.footerCol}>
            <Text style={pdfStyles.footerLabel}>Firma cliente</Text>
            {firmaBase64
              ? <Image src={firmaBase64} style={pdfStyles.firmaImg} />
              : <Text style={{ color: '#999' }}>Non firmato</Text>
            }
          </View>
        </View>

      </Page>

      {/* ── PAGINA 2 – Foto pesata (SEMPRE presente) ── */}
      <Page size="A4" style={pdfStyles.page2}>
        <Text style={pdfStyles.page2Title}>FOTO PESATA</Text>
        <Text style={pdfStyles.page2Subtitle}>{cantiere} — {fmtData(data)}</Text>
        <View style={pdfStyles.divider} />

        {fotoPesataUrl
          ? <Image src={fotoPesataUrl} style={pdfStyles.fotoPesataImg} />
          : (
            <View style={pdfStyles.fotoPesataBox}>
              <Text style={pdfStyles.fotoPesataNone}>Nessuna foto pesata allegata</Text>
            </View>
          )
        }
      </Page>
    </Document>
  );
}

// ─── COMPONENTE PRINCIPALE ────────────────────────────────────────────────────
function MieBolleForm({ dipendente, onBack }) {
  const [bolle, setBolle]         = useState([]);
  const [cantieri, setCantieri]   = useState([]);
  const [clienti, setClienti]     = useState([]);
  const [loading, setLoading]     = useState(true);
  const [filtroData, setFiltroData] = useState('');
  const [uploadingFotoId, setUploadingFotoId] = useState(null); // id bolla in upload
  const [erroreUpload, setErroreUpload]       = useState(null); // messaggio errore

  useEffect(() => { caricaDati(); }, [dipendente]);

  async function caricaDati() {
    setLoading(true);
    const [bolleSnap, cantSnap, cliSnap] = await Promise.all([
      get(ref(database, 'bolleForm')),
      get(ref(database, 'cantieri')),
      get(ref(database, 'clienti')),
    ]);
    if (cantSnap.exists()) setCantieri(Object.entries(cantSnap.val()).map(([k, v]) => ({ id: k, ...v })));
    if (cliSnap.exists())  setClienti(Object.entries(cliSnap.val()).map(([k, v]) => ({ id: k, ...v })));
    if (bolleSnap.exists()) {
      const tutte = Object.entries(bolleSnap.val()).map(([k, v]) => ({ id: k, ...v }));
      setBolle(
        tutte
          .filter(b => b.dipendenteId === dipendente.id)
          .sort((a, b) => b.createdAt - a.createdAt)
      );
    }
    setLoading(false);
  }

  function getCantiere(id) { return cantieri.find(c => c.id === id); }
  function getCliente(cantiereId) {
    const cant = getCantiere(cantiereId);
    return cant ? clienti.find(c => c.id === cant.clienteId) : null;
  }



async function handleAggiungiPesata(bolla, file) {
  if (!file) return;
  setUploadingFotoId(bolla.id);
  setErroreUpload(null);

  try {
    // 1. Upload su Cloudinary nella cartella 'pesate'
    const { imageUrl, publicId } = await uploadImmagine(file, 'pesate');

    // 2. Aggiorna il record Firebase con la nuova foto
  await update(ref(database, `bolleForm/${bolla.id}`), {
  fotoPesataUrl:        imageUrl,
  fotoPesataPubblicId:  publicId,
});

    // 3. Aggiorna lo stato locale senza ricaricare tutto
    setBolle(prev =>
  prev.map(b =>
    b.id === bolla.id
      ? { ...b, fotoPesataUrl: imageUrl, fotoPesataPubblicId: publicId, fotoPesataAggiuntoAt: Date.now() }
      : b
  )
);
  } catch (err) {
    setErroreUpload(`Errore upload foto: ${err.message}`);
  } finally {
    setUploadingFotoId(null);
  }
}


  const bolleFiltrate = filtroData
    ? bolle.filter(b => b.data === filtroData)
    : bolle;

  return (
    <div className="dashboard-container">
      <div className="sidebar">
        <h2><img src="CRG_logo.png" alt="crg" style={{ width: 150 }} /></h2>
        <div className="user-info">
          <p>{dipendente ? `${dipendente.nome} ${dipendente.cognome}` : ''}</p>
        </div>
        <button className="btn-logout" onClick={onBack}>Torna indietro</button>
      </div>

      <div className="form-bolla">
        <button className="btn-back-mobile" onClick={onBack} style={{ marginTop: 8 }}>Home</button>

        {/* FILTRO DATA */}
        <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: 10, marginTop: 50, flexWrap: 'wrap' }}>
          <label style={{ whiteSpace: 'nowrap' }}>Filtra per data</label>
          <input
            type="date"
            value={filtroData}
            onChange={e => setFiltroData(e.target.value)}
            style={{ flex: 1 }}
          />
          {filtroData && (
            <button className="btn-secondary small" onClick={() => setFiltroData('')}>Rimuovi</button>
          )}
        </div>

        {/* LISTA BOLLE */}
        {loading ? (
          <p style={{ color: '#666', textAlign: 'center' }}>Caricamento...</p>
        ) : bolleFiltrate.length === 0 ? (
          <p style={{ color: '#666', textAlign: 'center' }}>
            {filtroData ? `Nessuna bolla per il ${formattaData(filtroData)}` : 'Nessuna bolla compilata'}
          </p>
        ) : (
          <div className="bolle-list">

{erroreUpload && (
  <div style={{
    background: '#ffebee', color: '#c62828',
    borderRadius: 6, padding: '8px 12px',
    marginBottom: 10, fontSize: 13,
  }}>
    ⚠️ {erroreUpload}
    <button
      onClick={() => setErroreUpload(null)}
      style={{ marginLeft: 8, cursor: 'pointer', color: '#c62828', background: 'none', border: 'none', fontWeight: 'bold' }}
    >✕</button>
  </div>
)}

            {bolleFiltrate.map(bolla => {
              const cliente  = getCliente(bolla.cantiereId);
              const cantiere = getCantiere(bolla.cantiereId);

              const datiCompleti = {
                ...bolla,
                cliente:      cliente?.ragioneSociale || bolla.clienteId,
                cantiere:     cantiere?.luogo || bolla.cantiereId,
                firmaBase64:  bolla.firmaUrl,
                fotoPesataUrl: bolla.fotoPesataUrl || null,  // ← passata al PDF
              };

              return (
                <div key={bolla.id} className="bolla-item">
                  <div className="bolla-info">

  {/* ── NUOVO: numero bolla ── */}
  {bolla.numeroBolla && (
    <span style={{
      display: 'inline-flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#1a1a1a',
      borderRadius: 4,
      padding: '2px 8px',
      marginRight: 6,
      lineHeight: 1.2,
    }}>
      <span style={{ fontSize: 9, color: '#aaa', textTransform: 'uppercase', letterSpacing: 1 }}>#</span>
      <span style={{ fontSize: 15, fontWeight: 'bold', color: '#ffffff' }}>{bolla.numeroBolla}</span>
    </span>
  )}

                    <span className="bolla-data">{formattaData(bolla.data)}</span>
                    <span className="bolla-cantiere">{cantiere?.luogo}</span>
                    <span className="bolla-cliente">{cliente?.ragioneSociale}</span>
                    {bolla.firmaUrl && (
                      <span className="bolla-firmata">Firmata</span>
                    )}
{bolla.fotoPesataUrl ? (
  /* ── Foto già presente + pulsante sostituzione ── */
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginLeft: 4 }}>
    <span style={{
      fontSize: 11, color: '#2e7d32',
      background: '#e8f5e9', borderRadius: 4,
      padding: '1px 6px',
    }}>
      📷 Foto pesata
    </span>
    <label
      htmlFor={`foto-cambia-${bolla.id}`}
      title="Sostituisci foto pesata"
      style={{
        fontSize: 13,
        cursor: uploadingFotoId === bolla.id ? 'not-allowed' : 'pointer',
        opacity: uploadingFotoId === bolla.id ? 0.4 : 1,
        pointerEvents: uploadingFotoId === bolla.id ? 'none' : 'auto',
        lineHeight: 1,
      }}
    >
      {uploadingFotoId === bolla.id ? '⏳' : '✏️'}
      <input
        id={`foto-cambia-${bolla.id}`}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: 'none' }}
        onChange={e => handleAggiungiPesata(bolla, e.target.files[0])}
      />
    </label>
  </span>
) : (
  /* ── Foto assente: pulsante upload ── */
  <label
    htmlFor={`foto-pesata-${bolla.id}`}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      fontSize: 11,
      color: uploadingFotoId === bolla.id ? '#888' : '#1565c0',
      background: uploadingFotoId === bolla.id ? '#f5f5f5' : '#e3f2fd',
      borderRadius: 4,
      padding: '2px 8px',
      marginLeft: 4,
      cursor: uploadingFotoId === bolla.id ? 'not-allowed' : 'pointer',
      border: '1px dashed #90caf9',
      pointerEvents: uploadingFotoId === bolla.id ? 'none' : 'auto',
    }}
  >
    {uploadingFotoId === bolla.id ? '⏳ Caricamento...' : '➕ Aggiungi pesata'}
    <input
      id={`foto-pesata-${bolla.id}`}
      type="file"
      accept="image/*"
      capture="environment"
      style={{ display: 'none' }}
      onChange={e => handleAggiungiPesata(bolla, e.target.files[0])}
    />
  </label>
)}
                  </div>

                  <div className="bolla-azioni">
                    <PulsantiCondivisionePDF
                      documentoPDF={<BollaPDF dati={datiCompleti} />}
                      nomeFile={bolla.nomeFile || `bolla_${bolla.id}.pdf`}
                      testoCondivisione={`Bolla di lavoro del ${formattaData(bolla.data)} - ${cantiere?.luogo}`}
                      oggettoEmail={`Bolla ${formattaData(bolla.data)} - ${cantiere?.luogo}`}
                      corpoEmail={`In allegato la bolla di lavoro del ${formattaData(bolla.data)}.\n${cantiere?.luogo}\n${bolla.nomeAutista}`}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default MieBolleForm;